import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import { getPath } from "./router";
import { preloadPath } from "./flow-loader";
import "./index.css";

const root = document.getElementById("root")!;

// If build-time prerender filled #root, adopt it: the bundle is built with
// jetshake({ ssr: true }), so compiled output claims the server DOM in place
// (piece 158). Landing fully adopts; deep-linked lazy routes still bail to a
// clear + client re-render (TASK-SSR-002 lazy-route hydration boundary).
function mount() {
  if (root.hasChildNodes()) {
    hydrateRoot(root, <App />);
  } else {
    createRoot(root).render(<App />);
  }
}

// Deep link onto a lazy route: fetch its chunk BEFORE mounting so the
// prerendered HTML stays on screen instead of a blank frame while the
// chunk downloads. The page host then mounts synchronously from cache.
preloadPath(getPath()).then(mount, mount);
